import PropTypes from 'prop-types'
import MultiSelectDropdownComponent from '../../common/MulitSelectDropdown/MultiSelectDropdownComponent'
import {StyledSectionTitle} from '../../AdminPanelStyling'
import {useProjectDetails} from '../../../store/hooks/projectDetails'
import {SECTIONS} from '../../customSettings/Customization/helper'
const PointOfInterest = ({
  selectedData,
  setPointofInterestValue,
  enabled,
  isCompleted,
  showCustomLabels,
  setCustomLabelDialogProps
}) => {
  const {pointOfInterestsData} = useProjectDetails()

  return (
    <>
      <StyledSectionTitle variant='h5'> {'What Points of Interest do you want available?'} </StyledSectionTitle>
      <MultiSelectDropdownComponent
        selectAllTitle='Select All'
        dropDownTitle='Select POI'
        inputAndPreviewTitle='Points of Interest'
        dropDownModifiedTitle='Selected POIs'
        dropDownData={pointOfInterestsData}
        val={selectedData}
        setVal={setPointofInterestValue}
        enabled={enabled}
        isCompleted={isCompleted}
        showCustomLabels={showCustomLabels}
        section={SECTIONS.POINT_OF_INTERESTS}
        setCustomLabelDialogProps={setCustomLabelDialogProps}
      />
    </>
  )
}
PointOfInterest.propTypes = {
  selectedData: PropTypes.any.isRequired,
  setPointofInterestValue: PropTypes.func.isRequired,
  enabled: PropTypes.bool.isRequired,
  isCompleted: PropTypes.bool.isRequired,
  showCustomLabels: PropTypes.bool,
  setCustomLabelDialogProps: PropTypes.func
}

export default PointOfInterest
